module.exports = __webpack_public_path__ + "img/flattened-tasks.38b63ab8.svg";